<template>
    <v-dialog
        v-model="$store.state.scoreCard.allDialog"
        max-width="1300px"
        transition="dialog-transition"
    >
        <dynamic-toolbar
            title="Dispatch Score Card"
            :loading="loading.lists"
            color="indigo"
            icon="mdi-ab-testing"
            theme="dark"
        >
            <template #buttons>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.scoreCard.allDialog = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </template>
        </dynamic-toolbar>
        <v-card>
            <v-container grid-list-xs>
                <v-row>
                    <v-col cols="4">
                        <v-data-table
                            :headers="headersAvg"
                            :items="score['avg']"
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title class="white--text"
                                        >Avg</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-col>

                    <v-col cols="4">
                        <v-data-table
                            :headers="headersAvgM"
                            :items="score['month']"
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title class="white--text"
                                        >Avg By Month</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-col>

                    <v-col cols="4">
                        <v-data-table
                            :headers="headersAvgD"
                            :items="score['day']"
                        >
                            <template v-slot:top>
                                <v-toolbar color="primary" dense>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title class="white--text"
                                        >Avg By Day</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import DateRangeMenu from './../../../Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from './../../../Global/Utils/DynamicToolbar.vue';
export default {
    props: ['StartDate', 'EndDate'],
    components: {
        DynamicToolbar,
        DateRangeMenu
    },
    data: function() {
        return {
            loading: {
                lists: false,
                cost: false,
                dateRangeTotalCost: false,
                totalCostByType: false,
                totalCostByEquipment: false,
                totalCostByCategory: false,
                totalCostBySubcategory: false,
                report: false
            },
            score: [],
            headersAvg: [
                { text: 'Max Date', value: 'MaxOfDate' },
                { text: 'Avg Of Score', value: 'AvgOfdscore' }
            ],
            headersAvgM: [
                { text: 'Month', value: 'xDate' },
                { text: 'Score', value: 'xdscore' }
            ],

            headersAvgD: [
                { text: 'Day', value: 'Date' },
                { text: 'Score', value: 'dscore' }
            ]
        };
    },
    mounted() {
        this.loadDispatchScore();
    },
    methods: {
        loadDispatchScore: function() {
            var str = this.$store;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
            this.loading.lists = true;
            axios
                .post('dispatch/score/all', parms)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.score = response.data;
                    this.loading.lists = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
